export default "__VITE_ASSET__CQiChEP7__"